import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ENTITLEMENTS, EDITING_OPTIONS } from '../application-core/constants';
import DataOptions from '../core/DataOptions';
import HistoryViewer from '../core/HistoryViewer';
import { ProjectConsumer } from '../core/providers/ProjectProvider';
import TripleViewer from '../core/TripleViewer';
import { getGraphFromProject } from '../core/utils/utils';
import ResourceSummaryDetail from './ResourceSummaryDetail';
import NamedIndividualDetail from './NamedIndividualDetail';

class NamedIndividualData extends Component {

  constructor(props) {
    super(props);
    this.state = {
      view: 0
    };
  }

  changeView = (index) => this.setState({ view: index });

  render() {

    const { namedIndividualIRI, onDeleteNamedIndividual, project, ontologyIRI, buildLink, viewLang,
      hiddenProps, availableAnnotationProperty, editingOptions, propertyTemplates, associatedProject,
      useWorkflow, entitlements, projectUsers } = this.props;
    const { view } = this.state;
    const projectGraph = getGraphFromProject(project);

    return (
      <ProjectConsumer>
        {({ defaultLang }) => (
          <div>
            <DataOptions
              handleNotAvailable={true}
              id={namedIndividualIRI}
              graph={projectGraph}
              changeView={this.changeView}
              view={this.state.view}
              historyOption={true} />
            <div style={{ float: 'right', width: 'calc(100% - 60px)', marginBottom: '20px', paddingLeft: '10px' }}>
              <ResourceSummaryDetail
                handleNotAvailable={true}
                allowIRIchange={false}
                viewLang={viewLang}
                useWorkflow={useWorkflow}
                canPun={editingOptions && editingOptions.includes(EDITING_OPTIONS.PUNNING)}
                id={namedIndividualIRI}
                canDeprecate={true}
                graph={projectGraph}
                defaultLang={defaultLang}
                onDeleteResource={onDeleteNamedIndividual}
                permission="https://grafsync.graphifi.com/schema/om-entitlement/editOntology" />
              {view === 0 &&
                <NamedIndividualDetail
                  useWorkflow={useWorkflow}
                  projectUsers={projectUsers}
                  handleNotAvailable={true}
                  graph={projectGraph}
                  viewLang={viewLang}
                  entitlements={entitlements}
                  associatedProject={associatedProject}
                  propertyTemplates={propertyTemplates}
                  showOntologyProjects={true}
                  expectedTypes={["NamedIndividual"]}
                  hiddenProps={hiddenProps}
                  defaultLang={defaultLang}
                  availableAnnotationProperty={availableAnnotationProperty}
                  ontologyIRI={ontologyIRI}
                  buildLink={buildLink}
                  project={project}
                  id={namedIndividualIRI} />}
              {view === 1 &&
                <TripleViewer
                  requiredEntitlement={ENTITLEMENTS.EDIT_ONTOLOGY}
                  handleNotAvailable={true}
                  id={namedIndividualIRI}
                  graph={projectGraph} />}
              {view === 4 &&
                <HistoryViewer handleNotAvailable={true} id={namedIndividualIRI} graph={projectGraph} />}
            </div>
          </div>
        )}
      </ProjectConsumer>
    );
  }

}

NamedIndividualData.propTypes = {
  buildLink: PropTypes.func.isRequired,
  project: PropTypes.string.isRequired,
  namedIndividualIRI: PropTypes.string.isRequired,
  editingOptions: PropTypes.array,
  viewLang: PropTypes.string,
  hiddenProps: PropTypes.array,
  associatedProject: PropTypes.array,
  ontologyIRI: PropTypes.string.isRequired,
  onDeleteNamedIndividual: PropTypes.func.isRequired,
  propertyTemplates: PropTypes.array,
  availableAnnotationProperty: PropTypes.array
};

export default NamedIndividualData;